import { useState } from 'react';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import { Logo } from 'components/Logo/Logo';
import { StagingBanner } from 'components/StagingBanner/StagingBanner';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { BREAK_M } from 'utils/breakpoints';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { ContactUsButton } from './ContactUsButton/ContactUsButton';
import { DropdownContainer } from './DropdownContainer/DropdownContainer';
import { HelpModal } from './Help/HelpModal';
import { LoginItem } from './LoginItem/LoginItem';
import styles from './Navigation.module.css';
import { SupportDropdown } from './Support/SupportDropdown';

export const LoggedOutNavigation = () => {
  const [showSupport, setShowSupport] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { width } = useWindowDimensions();

  const handleSupportDropdown = () => {
    setShowSupport(!showSupport);
  };
  return (
    <div
      className={clsx(styles.navigationWrapper, {
        [styles.isStaging]: getEnvironment() === 'staging',
      })}
    >
      <StagingBanner />
      <nav className={styles.navigation} data-testid="navigation">
        <div className={styles.navItems}>
          <div className={clsx(styles.navItem, styles.loggedOutLogo)}>
            <Logo iconOnly={width <= BREAK_M} />
            <p className={styles.introducersLogoText}>
              <Trans>For Introducers</Trans>
            </p>
          </div>
        </div>
        <div className={styles.accountItems}>
          <SupportDropdown toggleDropdown={handleSupportDropdown} />
          <LoginItem />
        </div>
      </nav>
      {showSupport && (
        <DropdownContainer
          onClose={handleSupportDropdown}
          className={styles.navDropdown}
        >
          <ContactUsButton setShowHelpModal={setShowHelpModal} />
        </DropdownContainer>
      )}

      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </div>
  );
};
